<template>
  <div class="page-overlayer">
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Schedules</a></li>
        <li class="breadcrumb-item active" aria-current="page">Creat New Schedules</li>
      </ol>
    </div>
    <div class="sub-navbar">
      <div class="sub-left">
        <ul class="left-links over-drop">
          <li><a href="#" class="btn sched-btn ">Scheduling Period</a></li>

          <li>
            <div class="dropdown ">


  <div class="input-wrapper new-calender">
                <!--                                         <input type="text" class="form-control datepicker" id="myDate"  placeholder="27-2-2014 27-2-2014">-->

                <div class="  position-relative" v-click-outside="selectdate">
                  <a class="calendar-opener" @click.prevent="showCalendar = ! showCalendar">
                    <input type="text" class="form-control" :value="dateRangeValue" placeholder="27-2-2014 27-2-2014">
                  </a>
                  <div class="calendar-wrap disable-select" v-if="showCalendar">
                    <span class="close-calender" @click="selectdate"></span>
                    <weekly-datepicker  @clicked-show-detail="selection"></weekly-datepicker>
                    <!--                                              <weekly-datepicker :products="listProducts" @clicked-show-detail="selection" ></weekly-datepicker>-->
                    <!--                                                <datepicker :inline="true" v-model="date" @input="calculateWeeksDays()"></datepicker>-->
                  </div>
                </div>
              </div>



              <router-link  to="/schedule" class="btn btn-primary next-btn">Next</router-link>
<!--                <a href="new-schedule.html" class="btn btn-primary next-btn"> Next</a>-->
            </div>
          </li>



        </ul>
      </div>
      <div class="sub-right">
        <ul class="right-links">
          <li><a href="#" class="btn btn-primary"><span class="ico ico-add-user"></span>Invite
            Employee</a></li>
          <li><a href="#" class="btn btn-primary"><span class="ico ico-setting"></span> rules</a></li>
          <li>
            <div class="dropdown">
              <button class="btn btn-primary arrow-icon" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                All Shifts
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <a class="dropdown-item" href="#">Something else here</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="main-box two-column">
      <div class="left-side">
        <div class="schedules-list">
          <ul class="schedules-btn">
            <li><a href="new-schedule.html" class="btn btn-primary btn-sm">schedules</a></li>
            <li><a href="#" class="btn btn-gray btn-sm">Template</a></li>
            <li>
              <div class="nav-selectdrop">
                <select id="inputState" class="form-control form-control-sm ">
                  <option selected="">Copy from Template/Schedule</option>
                  <option>Copy from Template/Schedule</option>
                  <option>Copy from Template/Schedule</option>
                  <option>Copy from Template/Schedule</option>
                </select>
              </div>
            </li>
          </ul>
          <a href="#" class="btn btn-outline-primary btn-sm" data-toggle="modal"
             data-target="#publishModel"><i class="ico ico-upload-file"></i>Publish Shift</a>
        </div>

        <div class="start-week">
<!--          <h5>Week From Nov 29, 2021</h5>-->
          <h5>Week From {{ startWeek | moment("MMM  D, YYYY") }}</h5>
          <div class="week-btn">
            <a href="#" class="btn btn-gray ">Copy Week</a>
            <a href="#" class="btn btn-gray ">Remove All</a>
          </div>
        </div>

        <div class="week-table table-responsive-xxl">
          <table class="table ">
            <thead class="thead" >
            <tr>
              <th v-for="day in weeksDates" :key="day"><a class="btn btn-dark-gary btn-sm">{{day | moment('ddd, D MMM')}}</a></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td v-for="day in weeksDates" :key="day">
<!--                <p >{{newarray[day]}}</p>-->
                <div class="card-wrapper" v-for="info in newarray[day]" :key="info" >
                  <!-- <time >{{info.start_time | formatTime}} - {{info.end_time | formatTime}}</time> -->
                  <!-- <span> {{info.employee.id}}</span> -->

                  <div class="mini-card border-gray">
                    <div class="card-body">
                      <!-- <h4>{{info.employee.name }}</h4> -->
                      <span class="emp-designation"><i class="ico ico-fill-circle cyan"></i> {{info.jobRole.name }}</span>
                    </div>
                    <div class="overlayer-btn">
                      <ul>
                        <li>
                          <a href="#" class="over-btn"><i class="ico-Copy"></i></a>
                        </li>
                        <li>
                          <a href="#" class="over-btn" data-toggle="modal" data-target="#setup-rules">
                            <i class="ico-pencil"></i>
                          </a>
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
                <div class="shift-dropdown">
                  <a  class="btn btn-outline-primary btn-sm" data-toggle="collapse" href="#shift-dropdown102" role="button" aria-expanded="false" aria-controls="shift-dropdown">Add shift</a>
                  <div class="shift-dropmenu collapse"  id="shift-dropdown">
                    <div class="drop-header">
                      <div class="drop-title ">
                        <h5>Invite Employees</h5>
                        <p class="gray-text">Send your staff an invitation to join.</p>
                      </div>
                      <a data-toggle="collapse" class="close" href="#shift-dropdown" role="button" aria-expanded="false" aria-controls="shift-dropdown">
                        <span class="ico-cross"></span>
                      </a>

                    </div>
                    <div class="drop-body">

                      <div class="inputs-wrapper">
                        <div class="inputs-holder">
                          <div class="field-col">
                            <label>Employee Number:</label>
                            <input type="text" class="form-control" value="0012" placeholder="">
                          </div>
                          <div class="field-col">
                            <label>Employee NIC</label>
                            <input type="text" class="form-control" value="35202-6655686-8" placeholder="">
                          </div>
                          <div class="field-col">
                            <label for="exampleFormControlSelect1">Company</label>
                            <div class="nav-selectdrop" id="exampleFormControlSelect1">
                              <select  class="form-control  ">
                                <option selected="">Sixlogics</option>
                                <option>Sixlogics</option>
                                <option>Sixlogics</option>
                                <option>Sixlogics</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="inputs-holder">
                          <div class="field-col">
                            <label>Salary Period</label>
                            <div class="nav-selectdrop">
                              <select  class="form-control  ">
                                <option selected="">Sixlogics</option>
                                <option>Sixlogics</option>
                                <option>Sixlogics</option>
                                <option>Sixlogics</option>
                              </select>
                            </div>
                          </div>
                          <div class="field-col">
                            <label>Salary Period</label>
                            <div class="nav-selectdrop">
                              <select  class="form-control  ">
                                <option selected="">Sixlogics</option>
                                <option>Sixlogics</option>
                                <option>Sixlogics</option>
                                <option>Sixlogics</option>
                              </select>
                            </div>
                          </div>
                          <div class="field-col">
                            <label>Firsts Name:</label>
                            <input type="text" class="form-control" value="Asim" placeholder="">
                          </div>
                        </div>


                      </div>


                    </div>
                    <div class="drop-footer">
                      <a href="#" class="btn btn-outline-primary btn-sm">add another shift</a>
                      <a href="" class="btn btn-outline-primary btn-sm">Save</a>
                    </div>
                  </div>
                  <div class="shift-dropmenu collapse" id="shift-dropdown102">
                    <div class="drop-header">
                      <div class="drop-title ">
                        <h5>Set Times</h5>
                      </div>
                      <a data-toggle="collapse" class="close"
                         href="#shift-dropdown102" role="button"
                         aria-expanded="false" aria-controls="shift-dropdown">
                        <span class="ico-cross"></span>
                      </a>

                    </div>
                    <div class="drop-body">

                      <div class="inputs-wrapper">
                        <div class="inputs-holder">
                          <div class="field-col">
                            <label>Start Time</label>
                            <input type="time" class="form-control"
                                   value="14:00">
                          </div>
                          <div class="field-col">
                            <label>End Time</label>
                            <input type="time" class="form-control"
                                   value="22:00">
                          </div>
                          <div class="field-col">
                            <label for="exampleFormControlSelect1">Break
                              Time</label>
                            <div class="nav-selectdrop">
                              <select  class="form-control  ">
                                <option selected="">20 Min</option>
                                <option>30 Min</option>
                                <option>40 Min</option>
                                <option>60 Min</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="inputs-holder">
                          <div class="field-col">
                            <label>Job Role</label>
                            <div class="nav-selectdrop">
                              <select  class="form-control  ">
                                <option selected="">Waiter</option>
                                <option>Manger</option>
                                <option>Cook</option>
                              </select>
                            </div>
                          </div>
                          <div class="field-col">
                            <label>Employee</label>
                            <div class="nav-selectdrop">
                              <select  class="form-control  ">
                                <option selected="">Asim</option>
                                <option>Hassan</option>
                                <option>Ali</option>
                              </select>
                            </div>
                          </div>
                          <div class="field-col">
                            <label>Note (optional)</label>
                            <input type="text" class="form-control"
                                   value="Add a Note ...">
                          </div>
                        </div>


                      </div>


                    </div>
                    <div class="drop-footer">
                      <a href="#" class="btn btn-outline-primary btn-sm">add another
                        shift</a>
                      <a @click.prevent="Saveschedule" class="btn btn-outline-primary btn-sm">Save</a>
                    </div>
                  </div>
                </div>

              </td>

            </tr>




            </tbody>
          </table>
        </div>



      </div>
      <aside class="right-side">
        <div class="card ">
          <div class="card-head">
            <h3>Your Schedule overview</h3>
          </div>
          <div class="card-body">
            <div class="card-detail">
              <span>0 Shifts Need(s) Assignment</span>
            </div>
            <div class="card-detail">
              <span>0 hours Assigned</span>
            </div>
            <div class="card-detail">
              <strong>4 Rules Violation</strong>
            </div>
          </div>
        </div>
        <div class="card ">
          <div class="card-head">
            <h3>Total Hours per employee</h3>
          </div>
          <div class="card-body">
            <div class="card-detail text-gray">
<!--              <span>Nov 29 - Dec 03 </span>-->
              <span> {{ startWeek | moment("MMM  D") }} - {{ endWeek | moment("MMM  D") }} </span>
              <span>0 Hrs</span>
            </div>

          </div>
        </div>

        <div class="card ">
          <div class="card-head">
            <h3>Total Hours per employee</h3>
          </div>
          <div class="card-body">
            <div class="card-detail sub-heading">
              <span> {{ startWeek | moment("MMM  D") }} - {{ endWeek | moment("MMM  D") }} </span>
              <span>14:30 Hrs</span>
            </div>
            <div class="card-detail ">
              <span>Available shifts </span>
              <span>2:00 Hrs</span>
            </div>
            <div class="card-detail">
              <span><i class="ico ico-double-tick"></i> Asim Abbas</span>
              <span>5:00 Hrs</span>
            </div>
            <div class="card-detail">
              <span><i class="ico ico-double-tick"></i>Hamid Khan</span>
              <span>6:30 Hrs</span>

            </div>

          </div>
        </div>
      </aside>

    </div>
  </div>

</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';
  import weeklyDatepicker from "./datepicker";
  import router from '../../router/router';
  export default {
    name: 'signup',

     components: {
      'weeklyDatepicker': weeklyDatepicker
    },
    data() {
      return {
        date: new Date() ,
        otherdate : new Date(),
        startWeek :moment().weekday(1),
        endWeek :moment().weekday(7),
        dateRangeValue:moment().weekday(1).format('D-M-YYYY')+'  '+ moment().weekday(7).format('D-M-YYYY'),
        showCalendar :false,
        showCalendar1 :false,
        hideoverlay: true,

        schedule : [],
        weeksDates: [],
        newarray:[]
      }
    },

    serverPrefetch() {
    },
    mounted() {
      this.sepratedate();
      this.calculateWeeksDays();

      // this.main();
    },
    methods: {
selection(date) {

        this.startWeek = date[0].startDate;
        this.endWeek = date[1].endDate;
        //console.log(moment(this.weekStartDate).format('D-M-YYYY'),'=',moment(this.weekEndDate).format('D-M-YYYY'));
        this.dateRangeValue = moment(this.startWeek).format('D-M-YYYY') + ' ' + moment(this.endWeek).format('D-M-YYYY');
        this.calculateWeeksDays(this.startWeek);
        this.showCalendar = false;

      },
      calculateWeeksDays(date) {
        let curr = new Date(date);
        var newDate = moment(curr).add(-1, 'd').format('YYYY-MM-DD');
        newDate = moment(newDate);
        this.weeksDates = Array(7).fill().map(
          () => newDate.add(1, 'd').format('YYYY-MM-DD')
        );
        this.otherdate = moment(curr).add(6, 'd').format('YYYY-MM-DD');
        this.showCalendar = false;
      },

      selectdate(){
       // console.log('click');
        this.showCalendar = false;


      },
      sepratedate(){
        this.date = new Date(this.date).toISOString().slice(0, 10);
        //  this.otherdate = new Date(this.otherdate).toISOString().slice(0, 10);
      },

      main(){
        //console.log('main');
        // this.date = new Date(this.date).toISOString().slice(0, 10);
        // this.otherdate = new Date(this.otherdate).toISOString().slice(0, 10);
        this.sepratedate()
        const headers = {
          'Content-Type': 'application/json',
          'Device-Type': 'web',
          'Authorization': 'Bearer ' + window.localStorage.getItem("token")
        };


        this.company_id = window.localStorage.getItem("company_id");
        let params = {company_id: this.company_id, start_date: this.date, end_date:this.otherdate};

        this.$axios.get(this.$Schedule, {
          params: params,
          headers: headers
        }).then(response => {
          // console.log(response);
          this.schedule = response.data.result.schedules;
          this.weeksDates.forEach(wd => {
            this.newarray[wd] = [];
            this.schedule.forEach(sc => {
              if(wd == sc.date){
                this.newarray[wd].push(sc);
                // this.newarray[sc.date] = sc;
              }
            });
          });
        }).catch(error => {
          console.log(error);
        });
        console.log('mainend');
      }

    }
  }
</script>
